/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiExternalCreativeDataTypeFromJSON, ApiExternalCreativeDataTypeToJSON, } from './ApiExternalCreativeDataType';
import { ApiMediaFromJSON, ApiMediaToJSON, } from './ApiMedia';
export function ApiExternalCreativeDataFromJSON(json) {
    return ApiExternalCreativeDataFromJSONTyped(json, false);
}
export function ApiExternalCreativeDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'externalAdId': !exists(json, 'externalAdId') ? undefined : json['externalAdId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'media': !exists(json, 'media') ? undefined : ApiMediaFromJSON(json['media']),
        'mediaId': !exists(json, 'mediaId') ? undefined : json['mediaId'],
        'syncId': !exists(json, 'syncId') ? undefined : json['syncId'],
        'type': !exists(json, 'type') ? undefined : ApiExternalCreativeDataTypeFromJSON(json['type']),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function ApiExternalCreativeDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'externalAdId': value.externalAdId,
        'id': value.id,
        'media': ApiMediaToJSON(value.media),
        'mediaId': value.mediaId,
        'syncId': value.syncId,
        'type': ApiExternalCreativeDataTypeToJSON(value.type),
        'value': value.value,
    };
}
